import http, { request } from './http';

export interface NotificationItem {
  id: number;
  userId: number;
  title: string;
  content?: string | null;
  type: string;
  priority: string;
  readAt?: string | null;
  createdAt?: string | null;
  createdBy?: number | null;
  level?: string;
  presentation?: string;
  pushIm?: boolean;
  actionUrl?: string | null;
  actionLabel?: string | null;
  secondaryActionLabel?: string | null;
  requiresAck?: boolean;
  ackAt?: string | null;
  mergeKey?: string | null;
  mergedCount?: number;
  archivedAt?: string | null;
  extraJson?: string | null;
}

export interface NotificationPage {
  records: NotificationItem[];
  total: number;
  page: number;
  size: number;
}

export async function getMyNotifications(params: { page?: number; size?: number; unreadOnly?: boolean } = {}): Promise<NotificationPage> {
  return request<NotificationPage>(http.get('/notifications/me', { params }));
}

export async function getMyUnreadCount(): Promise<{ count: number }> {
  return request<{ count: number }>(http.get('/notifications/me/unread-count'));
}

export async function getPendingPopups(limit = 3): Promise<NotificationItem[]> {
  return request<NotificationItem[]>(http.get('/notifications/me/pending-popups', { params: { limit } }));
}

export async function getPendingToasts(limit = 8): Promise<NotificationItem[]> {
  return request<NotificationItem[]>(http.get('/notifications/me/pending-toasts', { params: { limit } }));
}

export async function createMyBellToast(payload: {
  title: string;
  content?: string;
  actionUrl?: string;
  actionLabel?: string;
  mergeKey?: string;
  type?: string;
  pushIm?: boolean;
}): Promise<NotificationItem> {
  return request<NotificationItem>(http.post('/notifications/me/toast', payload));
}

export async function markNotificationRead(id: number): Promise<{ success: boolean }> {
  return request<{ success: boolean }>(http.post(`/notifications/${id}/read`));
}

export async function acknowledgeNotification(id: number): Promise<{ success: boolean }> {
  return request<{ success: boolean }>(http.post(`/notifications/${id}/ack`));
}

export async function sendNotification(payload: {
  userId: number;
  title: string;
  content?: string;
  type?: string;
  priority?: string;
  level?: string;
  presentation?: string;
  pushIm?: boolean;
  actionUrl?: string;
  actionLabel?: string;
  secondaryActionLabel?: string;
  requiresAck?: boolean;
  mergeKey?: string;
  mergeTitleFormat?: string;
  extraJson?: string;
}): Promise<NotificationItem> {
  return request<NotificationItem>(http.post('/notifications/send', payload));
}
